import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-view-therapist',
  templateUrl: './view-therapist.component.html',
  styleUrls: ['./view-therapist.component.css']
})
export class ViewTherapistComponent implements OnInit {
  userId: any;
  imageUrl: any;
  viewTherapist: any;
  programList: any = [];
  selectedProgram: any;

  constructor(public service: MainService, private router: Router, private activatedroute: ActivatedRoute) {
    this.activatedroute.params.subscribe((res) => {
      this.userId = res.id
    })
  }


  ngOnInit(): void {
    this.viewProgramList()
    this.viewTherapistApi();
  }

  // program list api inntegration 
  viewProgramList() {
    this.service.getApi(ApiUrls.programList, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.programList = res.result;
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }

  // program list api inntegration 
  viewTherapistApi() {
    this.service.showSpinner();
    this.service.getApi(`${ApiUrls.viewTherapist}?userId=${this.userId}`, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.viewTherapist = res.result;
        this.programList.forEach((ele: any) => {
          if (ele._id == this.viewTherapist.programId) {
            this.selectedProgram = ele.title
          }
        });
        this.imageUrl = this.viewTherapist.profilePic;
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }

}
